import IndicatorEvolutionPage from './IndicatorEvolutionPage';

export default IndicatorEvolutionPage;


// WEBPACK FOOTER //
// ./src/pages/IndicatorEvolutionPage/index.js